import VueCqrs from '@cqrs/vue-component-cqrs';
import * as c from '@Evaluation/Estimations/Domain/commands-core';
import { EstimationsVote } from '@Evaluation/Model';
import { Component } from 'vue-facing-decorator';

@Component
export default class EstimationsCommands extends VueCqrs {

	invokeCreatePanelCommandV1(workspaceId: number, evalModelId: number, name: string, description: string, ownerEmail: string, responseDueDateIsoString: string | null)
	{
		const cmd = new c.CreatePanelCommandV1(workspaceId, 0, evalModelId, name, description, ownerEmail, responseDueDateIsoString);
		this.$command(cmd, name);
	}

	invokeUpdatePanelCommandV1(workspaceId: number, surveyId: number, evalModelId: number, name: string, description: string, ownerEmail: string, responseDueDateIsoString: string | null)
	{
		const cmd = new c.UpdatePanelCommandV1(workspaceId, surveyId, evalModelId, name, description, ownerEmail, responseDueDateIsoString);
		this.$command(cmd, surveyId.toString());
	}


	invokeClonePanelCommandV1(workspaceId: number, surveyId: number, cloneName: string)
	{
		const cmd = new c.ClonePanelCommandV1(workspaceId, surveyId, cloneName);
		this.$command(cmd, cloneName);
	}

	invokeDeletePanelCommandV1(workspaceId: number, surveyId: number)
	{
		const cmd = new c.DeletePanelCommandV1(workspaceId, surveyId);
		this.$command(cmd, surveyId.toString());
	}


	invokeOpenPanelAccessCommandV1(workspaceId: number, surveyId: number)
	{
		const cmd = new c.OpenPanelAccessCommandV1(workspaceId, surveyId);
		this.$command(cmd, surveyId.toString());
	}

	invokeClosePanelAccessCommandV1(workspaceId: number, surveyId: number)
	{
		const cmd = new c.ClosePanelAccessCommandV1(workspaceId, surveyId);
		this.$command(cmd, surveyId.toString());
	}

	invokeUpdatePanelAlternativesSettingsCommandV1(workspaceId: number, surveyId: number, respondentsAttributeId: number, viewDefId: string, descriptionTemplate: string)
	{
		const cmd = new c.UpdatePanelAlternativesSettingsCommandV1(workspaceId, surveyId, respondentsAttributeId, viewDefId, descriptionTemplate);
		this.$command(cmd, surveyId.toString());
	}

	invokeUpdatePanelAttributesSettingsCommandV1(workspaceId: number, surveyId: number, selectedAttributesIds: number[])
	{
		const cmd = new c.UpdatePanelAttributesSettingsCommandV1(workspaceId, surveyId, selectedAttributesIds);
		this.$command(cmd, surveyId.toString());
	}



	invokeUpdateAlternativesCommandV1(userId: number, workspaceId: number, surveyId: number)
	{
		const cmd = new c.UpdateAlternativesCommandV1(userId, workspaceId, surveyId);
		this.$command(cmd, surveyId.toString());
	}


	invokeSendEmailCommandV1(workspaceId: number, surveyId: number, projectUsersIds: number[], emailSubject: string, emailBody: string)
	{
		const cmd = new c.SendEmailCommandV1(workspaceId, surveyId, projectUsersIds, emailSubject, emailBody);
		this.$command(cmd, surveyId.toString());
	}

	invokeUpdatePanelistAlternativesCommandV1(workspaceId: number, surveyId: number, projectUserId: number, selectedIds: number[])
	{
		const cmd = new c.UpdatePanelistAlternativesCommandV1(workspaceId, surveyId, projectUserId, selectedIds);
		this.$command(cmd, projectUserId.toString());
	}

	invokeIncludePanelistCommandV1(workspaceId: number, surveyId: number, puId: number)
	{
		const cmd = new c.IncludePanelistCommandV1(workspaceId, surveyId, puId);
		this.$command(cmd, puId.toString());
	}

	invokeExcludePanelistCommandV1(workspaceId: number, surveyId: number, puId: number)
	{
		const cmd = new c.ExcludePanelistCommandV1(workspaceId, surveyId, puId);
		this.$command(cmd, puId.toString());
	}


	invokeSaveGroupVoteCommandV1(workspaceId: number, surveyId: number, questionId: string, value: number, comment: string)
	{
		const cmd = new c.SaveGroupVoteCommandV1(workspaceId, surveyId, questionId, value, comment);
		this.$command(cmd, questionId.toString());
	}

	invokeSaveGroupCommentCommandV1(workspaceId: number, surveyId: number, questionId: string, comment: string)
	{
		const cmd = new c.SaveGroupCommentCommandV1(workspaceId, surveyId, questionId, comment);
		this.$command(cmd, questionId.toString());
	}

	invokeSavePanelistCommentCommandV1(workspaceId: number, surveyId: number, projectUserId: number, questionId: string, comment: string)
	{
		const cmd = new c.SavePanelistCommentCommandV1(workspaceId, surveyId, projectUserId, questionId, comment);
		this.$command(cmd, questionId.toString());
	}

	invokeSavePanelistVoteCommandV1(workspaceId: number, surveyId: number, projectUserId: number, questionId: string, value: number, comment: string)
	{
		const cmd = new c.SavePanelistVoteCommandV1(workspaceId, surveyId, projectUserId, questionId, value, comment);
		this.$command(cmd, questionId.toString());
	}

	invokeSavePanelistVotesCommandV1(workspaceId: number, surveyId: number, projectUserId: number, alternativeId: number, votes: EstimationsVote[])
	{
		const cmd = new c.SavePanelistVotesCommandV1(workspaceId, surveyId, projectUserId, alternativeId, votes);
		this.$command(cmd, alternativeId.toString());
	}
}
